import axios from "axios";
import { translations } from "@/i18n/translations";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true, timeout: 90000 });

function localize(msg) {
  const lang = localStorage.getItem("vantex_lang") || "en";
  const map = translations[lang]?.errors || {};
  return map[msg] || msg;
}

export function formatApiError(detail) {
  if (detail == null) return localize("Qualcosa è andato storto. Riprova.");
  if (typeof detail === "string") return localize(detail);
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
